/* Painel Admin Consignação — Printar */
(function () {
  'use strict';

  const API      = 'https://elasticyear.com/api/printar/consignment/admin/admin-api.php';
  const root     = document.getElementById('ca-root');
  if (!root) return;

  const CID = root.dataset.customerId;
  let allClients  = [];
  let alertData   = {};
  let pedidosData = [];

  // ── Utils ──────────────────────────────────────────────────────────────────

  function qs(sel, ctx = document) { return ctx.querySelector(sel); }
  function qsa(sel, ctx = document) { return [...ctx.querySelectorAll(sel)]; }

  function toast(msg, type = 'success') {
    const wrap = qs('.consig-toasts') || (() => {
      const d = document.createElement('div');
      d.className = 'consig-toasts';
      document.body.appendChild(d);
      return d;
    })();
    const t = document.createElement('div');
    t.className = `consig-toast consig-toast--${type}`;
    t.textContent = msg;
    wrap.appendChild(t);
    setTimeout(() => t.remove(), 4000);
  }

  async function api(action, method = 'GET', body = null) {
    const url = `${API}?action=${action}&customer_id=${CID}`;
    const opts = { method, headers: { 'Content-Type': 'application/json' } };
    if (body) opts.body = JSON.stringify({ ...body, customer_id: CID });
    const res  = await fetch(url, opts);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'Erro na API');
    return json;
  }

  function fmt(v) {
    return Number(v || 0).toLocaleString('pt-PT', { style: 'currency', currency: 'EUR' });
  }

  function datePT(s) {
    if (!s) return '—';
    return new Date(s).toLocaleDateString('pt-PT');
  }

  function badge(estado) {
    return `<span class="ca-badge ca-badge--${estado}">${estado}</span>`;
  }

  // ── Render principal ───────────────────────────────────────────────────────

  async function init() {
    root.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div>A carregar...</div>';
    try {
      const [clientsRes, alertsRes, pedidosRes] = await Promise.all([
        api('clients'),
        api('alerts'),
        api('orders'),
      ]);
      allClients  = clientsRes.clients || [];
      alertData   = alertsRes;
      pedidosData = pedidosRes.pedidos || [];
      render();
    } catch (err) {
      root.innerHTML = `<div style="padding:4rem;text-align:center;opacity:.6">${err.message}</div>`;
    }
  }

  function render() {
    const totalClientes  = allClients.length;
    const aprovados      = allClients.filter(c => c.estado === 'aprovado').length;
    const pendentes      = allClients.filter(c => c.estado === 'pendente').length;
    const alertCount     = (alertData.pendentes?.length || 0) + (alertData.inativos?.length || 0);
    const pedidosCount   = pedidosData.length;

    root.innerHTML = `
      <div class="ca-header">
        <div>
          <h1 class="ca-header__title">Painel de Consignação</h1>
          <p class="ca-header__sub">Gestão de clientes, alertas e stock em campo</p>
        </div>
        <a href="/pages/consignacao" class="ca-btn ca-btn--preview" style="align-self:center;text-decoration:none">
          Ver portal de cliente
        </a>
      </div>

      <div class="ca-stats">
        <div class="ca-stat">
          <div class="ca-stat__label">Total clientes</div>
          <div class="ca-stat__value">${totalClientes}</div>
        </div>
        <div class="ca-stat">
          <div class="ca-stat__label">Aprovados</div>
          <div class="ca-stat__value">${aprovados}</div>
        </div>
        <div class="ca-stat ${pendentes > 0 ? 'ca-stat--warn' : ''}">
          <div class="ca-stat__label">Pendentes</div>
          <div class="ca-stat__value">${pendentes}</div>
        </div>
        <div class="ca-stat ${alertCount > 0 ? 'ca-stat--alert' : ''}">
          <div class="ca-stat__label">Alertas</div>
          <div class="ca-stat__value">${alertCount}</div>
        </div>
      </div>

      <div class="ca-tabs">
        <button class="ca-tab is-active" data-tab="clientes">Clientes</button>
        <button class="ca-tab" data-tab="alertas">
          Alertas ${alertCount > 0 ? `<span class="ca-tab__badge">${alertCount}</span>` : ''}
        </button>
        <button class="ca-tab" data-tab="stock">Stock em campo</button>
        <button class="ca-tab" data-tab="pedidos">
          Pedidos ${pedidosCount > 0 ? `<span class="ca-tab__badge">${pedidosCount}</span>` : ''}
        </button>
        <button class="ca-tab" data-tab="produtos">Produtos</button>
        <button class="ca-tab" data-tab="config">Config</button>
      </div>

      <div class="ca-panel is-active" id="ca-panel-clientes"></div>
      <div class="ca-panel" id="ca-panel-alertas"></div>
      <div class="ca-panel" id="ca-panel-stock"></div>
      <div class="ca-panel" id="ca-panel-pedidos"></div>
      <div class="ca-panel" id="ca-panel-produtos"></div>
      <div class="ca-panel" id="ca-panel-config"></div>
    `;

    // Tabs
    qsa('.ca-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        qsa('.ca-tab').forEach(t => t.classList.remove('is-active'));
        qsa('.ca-panel').forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const panel = qs(`#ca-panel-${btn.dataset.tab}`);
        if (panel) panel.classList.add('is-active');
        if (btn.dataset.tab === 'pedidos') renderPedidos();
        if (btn.dataset.tab === 'produtos') renderProducts();
        if (btn.dataset.tab === 'config') renderConfig();
      });
    });

    renderClients();
    renderAlerts();
    renderStock();
  }

  // ── Clientes ───────────────────────────────────────────────────────────────

  function renderClients(filter = '', estado = '') {
    const panel = qs('#ca-panel-clientes');
    let list = allClients;
    if (filter) {
      const q = filter.toLowerCase();
      list = list.filter(c =>
        c.nome_negocio?.toLowerCase().includes(q) ||
        c.email?.toLowerCase().includes(q) ||
        c.localidade?.toLowerCase().includes(q)
      );
    }
    if (estado) list = list.filter(c => c.estado === estado);

    panel.innerHTML = `
      <div class="ca-filter">
        <input class="ca-search" id="ca-search" type="search" placeholder="Pesquisar por nome, email ou localidade..." value="${filter}">
        <select class="ca-select" id="ca-estado-filter">
          <option value="">Todos os estados</option>
          <option value="pendente"  ${estado==='pendente'  ? 'selected':''}>Pendente</option>
          <option value="aprovado"  ${estado==='aprovado'  ? 'selected':''}>Aprovado</option>
          <option value="suspenso"  ${estado==='suspenso'  ? 'selected':''}>Suspenso</option>
        </select>
      </div>
      <div class="ca-table-wrap">
        <table class="ca-table">
          <thead>
            <tr>
              <th>Negócio</th>
              <th>Contacto</th>
              <th>Localidade</th>
              <th>Estado</th>
              <th>Desde</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            ${list.length === 0 ? `<tr><td colspan="6" class="ca-empty">Nenhum cliente encontrado.</td></tr>` :
              list.map(c => `
                <tr data-id="${c.id}">
                  <td><strong>${c.nome_negocio || '—'}</strong><br><span style="font-size:1.2rem;opacity:.55">${c.tipo_negocio || ''}</span></td>
                  <td>${c.email}<br><span style="opacity:.6">${c.telefone || ''}</span></td>
                  <td>${c.localidade || '—'}</td>
                  <td>${badge(c.estado)}</td>
                  <td style="white-space:nowrap">${datePT(c.created_at)}</td>
                  <td><div class="ca-actions">${clientActions(c)}</div></td>
                </tr>
              `).join('')
            }
          </tbody>
        </table>
      </div>
    `;

    // Filtros
    qs('#ca-search').addEventListener('input', e => renderClients(e.target.value, qs('#ca-estado-filter').value));
    qs('#ca-estado-filter').addEventListener('change', e => renderClients(qs('#ca-search').value, e.target.value));

    // Ações
    panel.addEventListener('click', e => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const id = parseInt(btn.closest('tr').dataset.id);
      handleClientAction(btn.dataset.action, id, btn);
    });
  }

  function clientActions(c) {
    const btns = [];
    btns.push(`<button class="ca-btn ca-btn--detail" data-action="detail">Ver</button>`);
    if (c.estado === 'aprovado' && c.shopify_customer_id) {
      btns.push(`<a class="ca-btn ca-btn--preview" href="/pages/consignacao?preview=${c.shopify_customer_id}" target="_blank">Portal</a>`);
    }
    if (c.estado === 'aprovado') {
      btns.push(`<button class="ca-btn ca-btn--approve" data-action="create-kit">Criar kit</button>`);
    }
    if (c.estado === 'pendente') {
      btns.push(`<button class="ca-btn ca-btn--approve" data-action="approve">Aprovar</button>`);
    }
    if (c.estado === 'aprovado') {
      btns.push(`<button class="ca-btn ca-btn--suspend" data-action="suspend">Suspender</button>`);
    }
    if (c.estado === 'suspenso') {
      btns.push(`<button class="ca-btn ca-btn--reactivate" data-action="reactivate">Reativar</button>`);
    }
    return btns.join('');
  }

  async function handleClientAction(action, id, btn) {
    const client = allClients.find(c => c.id == id);
    if (!client) return;

    if (action === 'detail') { openModal(client); return; }
    if (action === 'create-kit') { openKitModal(client); return; }

    if (!confirm(`Confirmas ${action === 'approve' ? 'aprovar' : action === 'suspend' ? 'suspender' : 'reativar'} "${client.nome_negocio}"?`)) return;

    const origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const map = { approve: 'approve', suspend: 'suspend', reactivate: 'reactivate' };
      await api(map[action], 'POST', { id });
      toast(`${client.nome_negocio} ${action === 'approve' ? 'aprovado' : action === 'suspend' ? 'suspenso' : 'reativado'}.`);
      await refreshClients();
    } catch (err) {
      toast(err.message, 'error');
      btn.disabled = false;
      btn.textContent = origText;
    }
  }

  async function refreshClients() {
    const res = await api('clients');
    allClients = res.clients || [];
    renderClients(qs('#ca-search')?.value || '', qs('#ca-estado-filter')?.value || '');
  }

  // ── Modal detalhe ──────────────────────────────────────────────────────────

  async function openModal(client) {
    const overlay = document.createElement('div');
    overlay.className = 'ca-modal-overlay';
    overlay.innerHTML = `<div class="ca-modal"><div class="consig-loading"><div class="consig-spinner"></div>A carregar...</div></div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });

    try {
      const data = await api(`client&id=${client.id}`);
      const c = data.client;
      qs('.ca-modal', overlay).innerHTML = `
        <button class="ca-modal__close">✕</button>
        <h2 class="ca-modal__title">${c.nome_negocio}</h2>
        ${[
          ['Estado', badge(c.estado)],
          ['E-mail', c.email],
          ['Telefone', c.telefone || '—'],
          ['NIF', c.nif || '—'],
          ['Tipo', c.tipo_negocio || '—'],
          ['Morada', `${c.morada || ''}, ${c.codigo_postal || ''} ${c.localidade || ''}`],
          ['Responsável', c.nome_responsavel || '—'],
          ['Cliente desde', datePT(c.created_at)],
          ['Aprovado em', datePT(c.data_aprovacao)],
          ['Limite de crédito', `
            <div class="ca-limit-form">
              <input class="ca-limit-input" id="ca-limit-val" type="number" step="0.01" value="${c.limite_credito || 0}">
              <button class="ca-btn ca-btn--detail" id="ca-limit-save">Guardar</button>
            </div>
          `],
        ].map(([l,v]) => `<div class="ca-detail-row"><span class="ca-detail-label">${l}</span><span class="ca-detail-value">${v}</span></div>`).join('')}
        <div style="margin-top:2rem">
          <div class="ca-actions">
            ${clientActions(c)}
          </div>
        </div>
      `;
      qs('.ca-modal__close', overlay).addEventListener('click', () => overlay.remove());
      qs('#ca-limit-save', overlay)?.addEventListener('click', async () => {
        const val = parseFloat(qs('#ca-limit-val', overlay).value);
        try {
          await api('set-limit', 'POST', { id: c.id, limite_credito: val });
          toast('Limite atualizado.');
          const idx = allClients.findIndex(x => x.id == c.id);
          if (idx >= 0) allClients[idx].limite_credito = val;
        } catch (err) { toast(err.message, 'error'); }
      });
      qs('.ca-modal', overlay).addEventListener('click', async e => {
        const btn = e.target.closest('[data-action]');
        if (!btn) return;
        const action = btn.dataset.action;
        if (action === 'detail') return;
        overlay.remove();
        await handleClientAction(action, c.id, btn);
      });
    } catch (err) {
      qs('.ca-modal', overlay).innerHTML = `<p style="opacity:.6">${err.message}</p>`;
    }
  }

  // ── Modal kit inicial (criado pelo comercial) ─────────────────────────────

  async function openKitModal(client) {
    const overlay = document.createElement('div');
    overlay.className = 'ca-modal-overlay';
    overlay.innerHTML = `<div class="ca-modal"><div class="consig-loading"><div class="consig-spinner"></div>A carregar catálogo...</div></div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });

    try {
      const data = await api('products');
      const prods = data.products || [];

      if (!prods.length) {
        qs('.ca-modal', overlay).innerHTML = `
          <button class="ca-modal__close">✕</button>
          <p class="ca-empty">Nenhum produto no catálogo de consignação.<br>Adiciona produtos no separador "Produtos" primeiro.</p>`;
        qs('.ca-modal__close', overlay).addEventListener('click', () => overlay.remove());
        return;
      }

      let html = `
        <button class="ca-modal__close">✕</button>
        <h2 class="ca-modal__title">Kit inicial — ${client.nome_negocio}</h2>
        <p style="font-size:1.3rem;opacity:.6;margin:0 0 2.4rem">Seleciona os produtos e quantidades para enviar ao cliente.</p>
        <div style="display:flex;flex-direction:column;gap:1.2rem;margin-bottom:2.4rem" id="ca-kit-items">`;

      prods.forEach(p => {
        html += `<div style="display:flex;align-items:center;gap:1.2rem;padding:1rem 0;border-bottom:1px solid rgba(0,0,0,.06)">
          ${p.imagem ? `<img src="${p.imagem}" style="width:4rem;height:4rem;object-fit:cover;border-radius:4px;flex-shrink:0">` : ''}
          <div style="flex:1;min-width:0">
            <div style="font-weight:600;font-size:1.3rem">${p.titulo}</div>
            <div style="font-size:1.2rem;opacity:.55">${p.preco > 0 ? p.preco.toLocaleString('pt-PT',{style:'currency',currency:'EUR'}) : '—'} / un.</div>
          </div>
          <div style="display:flex;align-items:center;gap:.6rem;flex-shrink:0">
            <button type="button" class="consig-qty-btn" onclick="this.nextElementSibling.value=Math.max(0,+this.nextElementSibling.value-1);caKitTotal()">−</button>
            <input type="number" min="0" value="0"
              style="width:5rem;text-align:center;border:1px solid rgba(0,0,0,.2);border-radius:6px;padding:.5rem;font-size:1.3rem"
              class="ca-kit-qty"
              data-pid="${p.id}"
              data-preco="${p.preco}"
              oninput="caKitTotal()">
            <button type="button" class="consig-qty-btn" onclick="this.previousElementSibling.value=+this.previousElementSibling.value+1;caKitTotal()">+</button>
          </div>
        </div>`;
      });

      html += `</div>
        <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:1.2rem">
          <div id="ca-kit-total" style="font-size:1.4rem;font-weight:600"></div>
          <button class="ca-btn ca-btn--approve" id="ca-kit-submit">Criar kit + gerar encomenda Shopify</button>
        </div>`;

      qs('.ca-modal', overlay).innerHTML = html;
      qs('.ca-modal__close', overlay).addEventListener('click', () => overlay.remove());
      caKitTotal();

      qs('#ca-kit-submit', overlay).addEventListener('click', async () => {
        const inputs = qsa('.ca-kit-qty', overlay);
        const items  = [];
        inputs.forEach(inp => {
          const qty = parseInt(inp.value);
          if (qty > 0) items.push({ variant_id: parseInt(inp.dataset.pid), qty });
        });
        if (!items.length) { toast('Seleciona pelo menos um produto.', 'warning'); return; }

        const btn = qs('#ca-kit-submit', overlay);
        btn.disabled = true;
        btn.textContent = 'A criar...';

        try {
          const res = await api('create-kit', 'POST', { client_id: client.id, items });
          toast(res.message || 'Kit criado com sucesso.', 'success');
          overlay.remove();
          // Atualizar tab pedidos se estiver ativo
          if (qs('.ca-tab.is-active')?.dataset.tab === 'pedidos') renderPedidos();
        } catch (err) {
          toast(err.message, 'error');
          btn.disabled = false;
          btn.textContent = 'Criar kit + gerar encomenda Shopify';
        }
      });
    } catch (err) {
      qs('.ca-modal', overlay).innerHTML = `<p style="opacity:.6">${err.message}</p>`;
    }
  }

  window.caKitTotal = function () {
    const inputs = [...document.querySelectorAll('.ca-kit-qty')];
    const total  = inputs.reduce((s, i) => s + (+i.value * +i.dataset.preco), 0);
    const el     = document.getElementById('ca-kit-total');
    if (el) el.textContent = total > 0 ? `Total: ${total.toLocaleString('pt-PT',{style:'currency',currency:'EUR'})}` : '';
  };

  // ── Alertas ────────────────────────────────────────────────────────────────

  function renderAlerts() {
    const panel = qs('#ca-panel-alertas');
    const pendentes = alertData.pendentes || [];
    const inativos  = alertData.inativos  || [];

    panel.innerHTML = `
      <p class="ca-section-title">Pagamentos pendentes (+ 7 dias)</p>
      ${pendentes.length === 0
        ? '<p class="ca-empty">Sem pagamentos pendentes.</p>'
        : pendentes.map(p => `
          <div class="ca-alert-card" data-report-id="${p.report_id}">
            <div>
              <p class="ca-alert-card__name">${p.nome_negocio}</p>
              <p class="ca-alert-card__sub">${p.email} · ${p.telefone || '—'}</p>
              <p class="ca-alert-card__sub">Report ${datePT(p.data_report)} · ${fmt(p.total_valor)}</p>
            </div>
            <div style="display:flex;flex-direction:column;align-items:flex-end;gap:.8rem">
              <span class="ca-badge ca-badge--suspenso">Pendente</span>
              <button class="ca-btn ca-btn--approve" style="font-size:1.2rem;padding:.5rem 1.2rem"
                data-action="mark-paid" data-rid="${p.report_id}">Marcar pago</button>
            </div>
          </div>
        `).join('')
      }

      <p class="ca-section-title" style="margin-top:3.2rem">Inativos (+ 30 dias sem report)</p>
      ${inativos.length === 0
        ? '<p class="ca-empty">Sem clientes inativos.</p>'
        : inativos.map(i => `
          <div class="ca-alert-card">
            <div>
              <p class="ca-alert-card__name">${i.nome_negocio}</p>
              <p class="ca-alert-card__sub">${i.email} · ${i.telefone || '—'}</p>
              <p class="ca-alert-card__sub">Último report: ${datePT(i.ultimo_report)} (${i.dias_inativo} dias)</p>
            </div>
            <span class="ca-badge ca-badge--pendente">${i.dias_inativo}d inativo</span>
          </div>
        `).join('')
      }
    `;

    panel.addEventListener('click', async e => {
      const btn = e.target.closest('[data-action="mark-paid"]');
      if (!btn) return;
      const rid = parseInt(btn.dataset.rid);
      if (!confirm('Confirmas que este pagamento foi recebido?')) return;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        await api('mark-paid', 'POST', { report_id: rid });
        toast('Report marcado como pago.');
        // Remover card do DOM imediatamente
        btn.closest('.ca-alert-card')?.remove();
        // Atualizar alertData e contador
        alertData.pendentes = (alertData.pendentes || []).filter(p => p.report_id !== rid);
      } catch (err) {
        toast(err.message, 'error');
        btn.disabled = false;
        btn.textContent = 'Marcar pago';
      }
    }, { once: true });
  }

  // ── Stock em campo ─────────────────────────────────────────────────────────

  async function renderStock() {
    const panel = qs('#ca-panel-stock');
    panel.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div>A carregar stock...</div>';
    try {
      const data = await api('stock');
      const stock = data.stock || [];
      if (!stock.length) { panel.innerHTML = '<p class="ca-empty">Sem stock em campo.</p>'; return; }

      // Agrupar por cliente
      const byClient = {};
      stock.forEach(s => {
        if (!byClient[s.nome_negocio]) byClient[s.nome_negocio] = [];
        byClient[s.nome_negocio].push(s);
      });

      panel.innerHTML = Object.entries(byClient).map(([nome, rows]) => `
        <div style="margin-bottom:3.2rem">
          <p class="ca-section-title">${nome}</p>
          <div class="ca-table-wrap">
            <table class="ca-table">
              <thead><tr><th>Produto</th><th>Variante</th><th style="text-align:right">Qty</th></tr></thead>
              <tbody>
                ${rows.map(r => `
                  <tr>
                    <td>${r.produto_titulo || '—'}</td>
                    <td style="opacity:.6">${r.variante_titulo || '—'}</td>
                    <td style="text-align:right;font-weight:600">${r.qty}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        </div>
      `).join('');
    } catch (err) {
      panel.innerHTML = `<p class="ca-empty">${err.message}</p>`;
    }
  }

  // ── Pedidos de kit / reposição ─────────────────────────────────────────────

  async function renderPedidos() {
    const panel = qs('#ca-panel-pedidos');
    panel.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div>A carregar pedidos...</div>';
    try {
      const data = await api('orders');
      pedidosData = data.pedidos || [];
      if (!pedidosData.length) {
        panel.innerHTML = '<p class="ca-empty">Sem pedidos pendentes.</p>';
        return;
      }
      panel.innerHTML = pedidosData.map(p => `
        <div class="ca-alert-card" style="flex-direction:column;align-items:stretch;gap:1.6rem" data-request-id="${p.id}">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:1.2rem">
            <div>
              <p class="ca-alert-card__name">${p.nome_negocio}</p>
              <p class="ca-alert-card__sub">${p.email} · ${p.tipo === 'kit_inicial' ? 'Kit inicial' : 'Reposição'} · ${datePT(p.data_pedido)}</p>
              <p class="ca-alert-card__sub">Total: ${fmt(p.valor_total)}</p>
            </div>
            <button class="ca-btn ca-btn--approve" data-action="mark-delivered" data-rid="${p.id}">
              Marcar entregue
            </button>
          </div>
          <div class="ca-table-wrap">
            <table class="ca-table" style="font-size:1.2rem">
              <thead><tr><th>Produto</th><th style="text-align:right">Qty</th><th style="text-align:right">Preço unit.</th></tr></thead>
              <tbody>
                ${(p.items || []).map(i => `
                  <tr>
                    <td>${i.produto_titulo}</td>
                    <td style="text-align:right">${i.qty}</td>
                    <td style="text-align:right">${fmt(i.preco_unitario)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        </div>
      `).join('');

      panel.addEventListener('click', async e => {
        const btn = e.target.closest('[data-action="mark-delivered"]');
        if (!btn) return;
        const rid = parseInt(btn.dataset.rid);
        if (!confirm('Confirmas que este kit foi entregue ao cliente? O stock será atualizado.')) return;
        btn.disabled = true;
        btn.textContent = '...';
        try {
          await api('mark-delivered', 'POST', { request_id: rid });
          toast('Kit marcado como entregue. Stock atualizado.');
          btn.closest('[data-request-id]')?.remove();
          pedidosData = pedidosData.filter(p => p.id !== rid);
          if (!panel.querySelector('[data-request-id]')) {
            panel.innerHTML = '<p class="ca-empty">Sem pedidos pendentes.</p>';
          }
        } catch (err) {
          toast(err.message, 'error');
          btn.disabled = false;
          btn.textContent = 'Marcar entregue';
        }
      });
    } catch (err) {
      panel.innerHTML = `<p class="ca-empty">${err.message}</p>`;
    }
  }

  // ── Produtos ───────────────────────────────────────────────────────────────

  async function renderProducts(searchQ = '') {
    const panel = qs('#ca-panel-produtos');
    panel.innerHTML = `
      <div class="ca-filter" style="margin-bottom:2.4rem">
        <input class="ca-search" id="ca-prod-search" type="search"
          placeholder="Pesquisar produtos Shopify para adicionar..."
          value="${searchQ}">
        <button class="ca-btn ca-btn--detail" id="ca-prod-search-btn">Pesquisar</button>
      </div>
      <div id="ca-prod-search-results"></div>
      <p class="ca-section-title" style="margin-top:3.2rem">No catálogo de consignação</p>
      <div id="ca-prod-list"><div class="ca-empty">A carregar...</div></div>
    `;

    qs('#ca-prod-search-btn').addEventListener('click', () => {
      const q = qs('#ca-prod-search').value.trim();
      if (q) searchProducts(q);
    });
    qs('#ca-prod-search').addEventListener('keydown', e => {
      if (e.key === 'Enter') { const q = e.target.value.trim(); if (q) searchProducts(q); }
    });

    try {
      const data = await api('products');
      renderProductList(data.products || []);
    } catch (err) {
      qs('#ca-prod-list').innerHTML = `<p class="ca-empty">${err.message}</p>`;
    }
  }

  function renderProductList(products) {
    const el = qs('#ca-prod-list');
    if (!products.length) {
      el.innerHTML = '<p class="ca-empty">Nenhum produto no catálogo de consignação.<br>Pesquisa um produto acima para adicionar.</p>';
      return;
    }
    el.innerHTML = `
      <div class="ca-table-wrap">
        <table class="ca-table">
          <thead><tr><th>Produto</th><th>Preço base</th><th>Variantes</th><th></th></tr></thead>
          <tbody>
            ${products.map(p => `
              <tr data-pid="${p.id}">
                <td>
                  ${p.imagem ? `<img src="${p.imagem}" style="width:4rem;height:4rem;object-fit:cover;border-radius:4px;vertical-align:middle;margin-right:1rem">` : ''}
                  <strong>${p.titulo}</strong>
                </td>
                <td>${p.preco > 0 ? p.preco.toLocaleString('pt-PT',{style:'currency',currency:'EUR'}) : '—'}</td>
                <td style="opacity:.6">${p.variants}</td>
                <td>
                  <button class="ca-btn ca-btn--suspend" style="font-size:1.2rem;padding:.5rem 1.2rem"
                    data-action="product-remove" data-pid="${p.id}">Remover</button>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;

    el.addEventListener('click', async e => {
      const btn = e.target.closest('[data-action="product-remove"]');
      if (!btn) return;
      const pid = parseInt(btn.dataset.pid);
      const row = btn.closest('tr');
      const name = row.querySelector('strong')?.textContent || 'produto';
      if (!confirm(`Remover "${name}" do catálogo de consignação?`)) return;
      btn.disabled = true; btn.textContent = '...';
      try {
        await api('product-remove', 'POST', { product_id: pid });
        toast(`"${name}" removido do catálogo.`);
        renderProducts();
      } catch (err) {
        toast(err.message, 'error');
        btn.disabled = false; btn.textContent = 'Remover';
      }
    });
  }

  async function searchProducts(q) {
    const el = qs('#ca-prod-search-results');
    el.innerHTML = '<p style="opacity:.5;font-size:1.3rem;margin-bottom:1.6rem">A pesquisar...</p>';
    try {
      const data = await api(`products-search&q=${encodeURIComponent(q)}`);
      const prods = data.products || [];
      if (!prods.length) { el.innerHTML = '<p class="ca-empty">Nenhum produto encontrado.</p>'; return; }
      el.innerHTML = `
        <p class="ca-section-title">Resultados da pesquisa</p>
        <div class="ca-table-wrap">
          <table class="ca-table">
            <thead><tr><th>Produto</th><th>Preço</th><th>Estado</th><th></th></tr></thead>
            <tbody>
              ${prods.map(p => `
                <tr data-pid="${p.id}">
                  <td>
                    ${p.imagem ? `<img src="${p.imagem}" style="width:4rem;height:4rem;object-fit:cover;border-radius:4px;vertical-align:middle;margin-right:1rem">` : ''}
                    ${p.titulo}
                  </td>
                  <td>${p.preco > 0 ? p.preco.toLocaleString('pt-PT',{style:'currency',currency:'EUR'}) : '—'}</td>
                  <td>${p.ja_consignacao ? '<span class="ca-badge ca-badge--aprovado">No catálogo</span>' : '<span style="opacity:.4;font-size:1.2rem">—</span>'}</td>
                  <td>
                    ${p.ja_consignacao
                      ? `<span style="opacity:.4;font-size:1.2rem">já adicionado</span>`
                      : `<button class="ca-btn ca-btn--approve" style="font-size:1.2rem;padding:.5rem 1.2rem"
                           data-action="product-add" data-pid="${p.id}" data-name="${p.titulo.replace(/"/g,'&quot;')}">
                           Adicionar
                         </button>`
                    }
                  </td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;

      el.addEventListener('click', async e => {
        const btn = e.target.closest('[data-action="product-add"]');
        if (!btn) return;
        const pid = parseInt(btn.dataset.pid);
        const name = btn.dataset.name;
        btn.disabled = true; btn.textContent = '...';
        try {
          await api('product-add', 'POST', { product_id: pid });
          toast(`"${name}" adicionado ao catálogo.`);
          renderProducts();
          qs('#ca-prod-search-results').innerHTML = '';
          qs('#ca-prod-search').value = '';
        } catch (err) {
          toast(err.message, 'error');
          btn.disabled = false; btn.textContent = 'Adicionar';
        }
      }, { once: true });
    } catch (err) {
      el.innerHTML = `<p class="ca-empty">${err.message}</p>`;
    }
  }

  // ── Config: tiers de desconto ─────────────────────────────────────────────

  async function renderConfig() {
    const panel = qs('#ca-panel-config');
    panel.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div>A carregar...</div>';
    try {
      const data = await api('discount-tiers');
      let tiers = data.tiers || [];
      renderTierEditor(panel, tiers);
    } catch (err) {
      panel.innerHTML = `<p class="ca-empty">${err.message}</p>`;
    }
  }

  function renderTierEditor(panel, tiers) {
    panel.innerHTML = `
      <p class="ca-section-title">Ranking de descontos</p>
      <p style="font-size:1.3rem;opacity:.6;margin:0 0 2.4rem">
        Define os patamares de vendas acumuladas (€) e o desconto correspondente (%).
        O desconto é aplicado automaticamente ao valor dos reports de vendas.
      </p>
      <div id="ca-tier-rows" style="display:flex;flex-direction:column;gap:1.2rem;margin-bottom:2.4rem"></div>
      <div style="display:flex;gap:1.2rem;flex-wrap:wrap">
        <button class="ca-btn ca-btn--detail" id="ca-tier-add">+ Adicionar patamar</button>
        <button class="ca-btn ca-btn--approve" id="ca-tier-save">Guardar</button>
      </div>
      <div id="ca-tier-msg" style="margin-top:1.6rem;font-size:1.3rem"></div>
    `;

    const rowsEl = qs('#ca-tier-rows', panel);

    function addRow(t = {}) {
      const row = document.createElement('div');
      row.className = 'ca-tier-row';
      row.style.cssText = 'display:flex;align-items:center;gap:1.2rem;flex-wrap:wrap;padding:1.2rem;background:rgba(0,0,0,.03);border-radius:6px';
      row.innerHTML = `
        <div style="display:flex;flex-direction:column;gap:.4rem;flex:1;min-width:120px">
          <label style="font-size:1.1rem;font-weight:600;opacity:.6">Vendas acumuladas (€)</label>
          <input type="number" min="0" step="0.01" class="ca-tier-min" value="${t.min_vendido ?? ''}"
            style="border:1px solid rgba(0,0,0,.2);border-radius:6px;padding:.7rem 1rem;font-size:1.3rem" placeholder="0">
        </div>
        <div style="display:flex;flex-direction:column;gap:.4rem;flex:1;min-width:100px">
          <label style="font-size:1.1rem;font-weight:600;opacity:.6">Desconto (%)</label>
          <input type="number" min="0" max="100" step="0.1" class="ca-tier-pct" value="${t.desconto_pct ?? ''}"
            style="border:1px solid rgba(0,0,0,.2);border-radius:6px;padding:.7rem 1rem;font-size:1.3rem" placeholder="5">
        </div>
        <div style="display:flex;flex-direction:column;gap:.4rem;flex:2;min-width:140px">
          <label style="font-size:1.1rem;font-weight:600;opacity:.6">Label (ex: Bronze)</label>
          <input type="text" class="ca-tier-label" value="${t.label ?? ''}"
            style="border:1px solid rgba(0,0,0,.2);border-radius:6px;padding:.7rem 1rem;font-size:1.3rem" placeholder="Bronze">
        </div>
        <button type="button" class="ca-btn ca-btn--suspend" style="align-self:flex-end;padding:.7rem 1.2rem;font-size:1.2rem"
          onclick="this.closest('.ca-tier-row').remove()">Remover</button>
      `;
      rowsEl.appendChild(row);
    }

    tiers.forEach(addRow);

    qs('#ca-tier-add', panel).addEventListener('click', () => addRow());

    qs('#ca-tier-save', panel).addEventListener('click', async () => {
      const rows = qsa('.ca-tier-row', panel);
      const tiersOut = rows.map(r => ({
        min_vendido:  parseFloat(qs('.ca-tier-min', r).value)  || 0,
        desconto_pct: parseFloat(qs('.ca-tier-pct', r).value)  || 0,
        label:        qs('.ca-tier-label', r).value.trim(),
      })).filter(t => t.desconto_pct > 0);

      tiersOut.sort((a, b) => a.min_vendido - b.min_vendido);

      const btn = qs('#ca-tier-save', panel);
      btn.disabled = true; btn.textContent = 'A guardar...';
      const msgEl = qs('#ca-tier-msg', panel);
      try {
        await api('save-discount-tiers', 'POST', { tiers: tiersOut });
        msgEl.style.color = '#237804';
        msgEl.textContent = '✓ Tiers guardados com sucesso.';
        toast('Tiers de desconto guardados.');
      } catch (err) {
        msgEl.style.color = '#c0392b';
        msgEl.textContent = err.message;
        toast(err.message, 'error');
      } finally {
        btn.disabled = false; btn.textContent = 'Guardar';
      }
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  init();
})();
